document.querySelectorAll<HTMLElement>('[data-model-directory]').forEach(directory => {
  const search = directory.querySelector<HTMLInputElement>('[data-directory-search]')
  const filters = [...directory.querySelectorAll<HTMLButtonElement>('.models-filters button')]
  const items = [...directory.querySelectorAll<HTMLElement>('[data-directory-item]')]
  const groups = [...directory.querySelectorAll<HTMLElement>('.models-provider, [data-directory-group]')]
  const status = directory.querySelector<HTMLElement>('[data-directory-status]')
  const reset = directory.querySelector<HTMLButtonElement>('[data-directory-reset]')
  let type = 'all'
  const update = () => {
    const words = (search?.value.trim().toLocaleLowerCase() ?? '').split(/\s+/).filter(Boolean)
    let visible = 0
    items.forEach(item => {
      const provider = item.closest<HTMLElement>('.models-provider')?.dataset.provider
      const matchesFilter = type === 'all' || type === provider || item.dataset[type] === 'true'
      const text = item.dataset.search?.toLocaleLowerCase() ?? ''
      item.hidden = !matchesFilter || !words.every(word => text.includes(word))
      if (!item.hidden) visible++
    })
    groups.forEach(group => { group.hidden = ![...group.querySelectorAll<HTMLElement>('[data-directory-item]')].some(item => !item.hidden) })
    filters.forEach(button => {
      const selected = button.dataset.filter === type
      button.classList.toggle('active', selected)
      button.setAttribute('aria-pressed', String(selected))
    })
    if (status) status.textContent = visible ? `${visible} of ${items.length} shown.` : 'No matches. Try a different search or show all results.'
    if (reset) reset.hidden = visible !== 0
  }
  search?.addEventListener('input', update)
  filters.forEach(button => button.addEventListener('click', () => { type = button.dataset.filter ?? 'all'; update() }))
  reset?.addEventListener('click', () => { if (search) search.value = ''; type = 'all'; update(); search?.focus() })
  update()
})

const sectionNav = document.querySelector<HTMLElement>('.models-section-nav')
if (sectionNav && 'IntersectionObserver' in window) {
  const anchors = [...sectionNav.querySelectorAll<HTMLAnchorElement>('a[href^="#"]')]
  const targets = anchors.map(anchor => document.getElementById(anchor.hash.slice(1))).filter((target): target is HTMLElement => target !== null)
  const observer = new IntersectionObserver(() => {
    const active = [...targets].reverse().find(target => target.getBoundingClientRect().top <= 190) ?? targets[0]
    anchors.forEach(anchor => { const selected = anchor.hash === `#${active?.id}`; anchor.classList.toggle('active', selected); if (selected) anchor.setAttribute('aria-current', 'location'); else anchor.removeAttribute('aria-current') })
  }, { rootMargin: '-180px 0px -60% 0px' })
  targets.forEach(target => observer.observe(target))
}
